var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile04Readonly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FCFCFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 9.51265V12.2663C17.3333 12.6397 17.3333 12.8264 17.406 12.969C17.4699 13.0944 17.5719 13.1964 17.6973 13.2603C17.8399 13.333 18.0266 13.333 18.4 13.333H21.1537M21.3333 14.6585V19.4663C21.3333 20.5864 21.3333 21.1465 21.1153 21.5743C20.9236 21.9506 20.6176 22.2566 20.2413 22.4484C19.8134 22.6663 19.2534 22.6663 18.1333 22.6663H13.8666C12.7465 22.6663 12.1865 22.6663 11.7586 22.4484C11.3823 22.2566 11.0764 21.9506 10.8846 21.5743C10.6666 21.1465 10.6666 20.5864 10.6666 19.4663V12.533C10.6666 11.4129 10.6666 10.8529 10.8846 10.425C11.0764 10.0487 11.3823 9.74274 11.7586 9.55099C12.1865 9.33301 12.7465 9.33301 13.8666 9.33301H16.0078C16.497 9.33301 16.7416 9.33301 16.9718 9.38827C17.1758 9.43726 17.3709 9.51807 17.5499 9.62773C17.7517 9.75141 17.9246 9.92436 18.2706 10.2703L20.396 12.3957C20.7419 12.7417 20.9149 12.9146 21.0386 13.1164C21.1482 13.2954 21.229 13.4905 21.278 13.6945C21.3333 13.9247 21.3333 14.1693 21.3333 14.6585Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile04Readonly);
export default __webpack_public_path__ + "static/media/file-04-readonly.52cb6f5f0acc02f6c24b94973631e8a5.svg";
export { ForwardRef as ReactComponent };